import { capitalizeEachWordText } from './capitalizeEachWordText'
import { greetingMessage } from 'presentation/utils/greetingMessage'

// Formata o corpo do texto de pendencia do tipo CRMO_CREATED_PENDENCY_AUTH_DIVERGENCE
export const formatObservations = (
  procedureObservation = '',
  opmeObservation = '',
  doctorName = ''
): string => {
  let divergencesList = ''

  if (procedureObservation?.trim()) {
    const procedureItems = procedureObservation
      .split(/\r?\n/)
      .map((l) => l.trim())
      .filter((l) => l.length)
      .join('\\n')
      .split('\\n')
      .map((item: string) => `- ${item}  \n`)

    procedureItems.forEach((item) => {
      divergencesList += item
    })
  }

  if (opmeObservation?.trim()) {
    const opmeItems = opmeObservation
      .split(/\r?\n/)
      .map((l) => l.trim())
      .filter((l) => l.length)
      .join('\\n')
      .split('\\n')
      .map((item: string) => `- ${item}  \n`)

    opmeItems.forEach((item) => {
      divergencesList += item
    })
  }

  const messageBody = [
    `Prezado(a) **Dr(a) ${capitalizeEachWordText(
      doctorName || '-'
    )}, ${greetingMessage?.()}** Informamos que o processo foi finalizado pelo convênio com as seguintes divergências:`,
    `${divergencesList}`,
    `Podemos finalizar o processo conforme autorização da operadora? Caso haja discordância, gentileza encaminhar relatório para reanálise.`
  ]

  return messageBody.join('\n\n')
}
